import React from "react";
import '../../../entrydoor.css';

const DoorLiteSearch = ({ placeholder = "Search door lites...", onChange }) => {
    return (
        <div className="a-container">
            <label>Search</label>
            <input
                type="text"
                className="doorlite-search-input"
                placeholder={placeholder}
                onChange={(e) => onChange(e.target.value)}
            />
        </div>
    );
};

export default DoorLiteSearch;
